import React, { useEffect } from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { SuccessInsert } from '../components/SuccessInsert';
import { ConnectionInsert } from '../components/ConnectionInsert';
import { BundleSection } from '../components/BundleSection';
import { OrderBumpSection } from '../components/OrderBumpSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { DecisionSection } from '../components/DecisionSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { StickyButton } from '../components/StickyButton';
import { initMetaPixel } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen w-full bg-charcoal relative overflow-x-hidden" data-id="element-290">
      <AnnouncementBar data-id="element-291" />
      <HeroSection data-id="element-292" />
      <SocialProofSection data-id="element-293" />
      <SuccessInsert data-id="element-294" />
      <ConnectionInsert data-id="element-295" />
      <BundleSection data-id="element-296" />
      <OrderBumpSection data-id="element-297" />
      <TestimonialsSection data-id="element-298" />
      <DecisionSection data-id="element-299" />
      <FAQSection data-id="element-300" />
      <Footer data-id="element-301" />
      <StickyButton data-id="element-302" />
    </main>;
}